import { Link } from "react-router-dom";
// reactstrap components
import {
  Navbar,
  Nav,
  Container,
} from "reactstrap";
import UserProfileMenu from "components/UserProfileMenu";

const AdminNavbar = (props) => {
  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h3 mb-0 text-capitalize d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UserProfileMenu />
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
